/**
 * @generated SignedSource<<37242c4475628d1cd353864482049630>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SideNavBarFragment_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeHeaderFragment_session" | "useGetSideNavBarItemsFragment_session">;
  readonly " $fragmentType": "SideNavBarFragment_session";
};
export type SideNavBarFragment_session$key = {
  readonly " $data"?: SideNavBarFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"SideNavBarFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SideNavBarFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeHeaderFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetSideNavBarItemsFragment_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "063717a548adb2908272b3327bcec6e6";

export default node;
